import { useContext } from "react";
import SellersContext from "../context/SellersProvider.tsx";

function useSellers() {
  return useContext(SellersContext);
}

export default useSellers;
